import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/65901499-5f66-45bd-bd62-ec85cd46ba4a/d8a0f3b6-ce91-4b8a-af81-e3e635f578fd_Screenshot-2026-04-11-at-15.27.04.png?v=8641f661bc7535cce0d5531ed27ef975"
          alt="Trading Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628]/50 via-[#0d1f3c]/30 to-[#1a3a6b]/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-20 pb-12">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-blue-500/20 border border-blue-400/40 text-blue-300 text-xs font-semibold px-4 py-2 rounded-full mb-6">
            <i className="ri-line-chart-line"></i>
            Análises Profissionais 2026 · Prop Firms · Futuros
          </div>

          {/* Title */}
          <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-6 whitespace-nowrap">
            Diário de <span className="text-blue-400">1 Trader</span>
          </h1>

          <p className="text-lg md:text-xl text-slate-300 mb-8 leading-relaxed max-w-2xl">
            Comparações detalhadas, estratégias comprovadas e análises imparciais para maximizar os seus resultados no trading de futuros através de Prop Firms.&nbsp; Tudo em português de Portugal.
          </p>

          {/* Stats */}
          <div className="flex flex-wrap gap-8 mb-8">
            {[
              { value: '6+', label: 'Prop Firms Analisadas' },
              { value: '10+', label: 'Estratégias Detalhadas' },
              { value: '50+', label: 'Artigos de Trading' },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-2xl font-extrabold text-blue-400">{stat.value}</div>
                <div className="text-sm text-slate-400">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/comparacao"
              className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 text-white font-bold px-8 py-4 rounded-full text-base transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-award-line"></i>
              Ver Comparação Completa
            </Link>
            <Link
              to="/estrategias"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold px-8 py-4 rounded-full text-base transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-book-open-line"></i>
              Estratégias Gratuitas
            </Link>
            <Link
              to="/trading-live"
              className="inline-flex items-center justify-center gap-2 bg-red-600/80 hover:bg-red-600 border border-red-400/40 text-white font-semibold px-8 py-4 rounded-full text-base transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-2 h-2 bg-white rounded-full animate-pulse inline-block"></span>
              Trading Live
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 text-xs">
        <span>Explorar</span>
        <i className="ri-arrow-down-line animate-bounce text-lg"></i>
      </div>
    </section>
  );
}
